import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const pressDeleteEndpoint = ApiEndpoints.press.Delete;
const pressListEndpoint = ApiEndpoints.press.List;
const pressEditPath = "edit-press";
const tableHeader = ["Date","Title","Slug", "publication"];
const tbody = ["date","title","slug", "publication"];

export default function Press() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", pressListEndpoint);
      const result = response.pressReleases;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (press_id) => {
      const payload = { press_id };
      try {
        const response = await ApiRequest("POST", pressDeleteEndpoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'press Management',
      user: 'Admin',
      innerpage: 'press Management / press'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-press">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={pressEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
